import ComplianceStrategy
  from './compliance-strategy';

export default class WhitelistedComplianceStrategy extends ComplianceStrategy {
    getDefaultCountriesCompliance = () => [];
}
